<template>
  <div class="signin">
    <div class="signin_title">信华利筑项管平台</div>
    <div class="form">
      <el-form ref="form" :model="form">
        <el-form-item
          prop="user_phone"
          :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            {
              pattern: phoneReg,
              message: '请输入正确的手机号',
              trigger: 'change',
            },
          ]"
        >
          <el-input clearable v-model.trim="form.user_phone" placeholder="请输入手机号"> </el-input>
        </el-form-item>
        <el-form-item
          prop="user_pwd"
          :rules="[
            { required: true, message: '请输入密码', trigger: 'change' },
            {
              pattern: passReg,
              message: '请输入由字母和数字组成8-16位的密码',
              trigger: 'change',
            },
          ]"
        >
          <el-input placeholder="请输入密码" v-model.trim="form.user_pwd"></el-input>
        </el-form-item>

        <el-form-item
          prop="user_pwd_confirm"
          :rules="[
            { required: true, message: '请再次输入密码', trigger: 'change' },
            { validator: validatePassword, trigger: 'change' },
          ]"
        >
          <el-input clearable placeholder="请输入确认密码" v-model.trim="form.user_pwd_confirm"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="code" :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]">
          <el-input clearable placeholder="请输入验证码" v-model.trim="form.code"> </el-input>
          <el-button type="primary" v-if="seconds == '' || seconds == 60" @click="sendCode">获取验证码 </el-button>
          <el-button type="primary" v-else @click="sendCode">{{ seconds }}s后重新获取</el-button>
        </el-form-item>
        <div class="left">
          <el-checkbox v-model="isRead" :true-label="1" :false-label="0" class="mr-6"></el-checkbox>
          <span>已认真阅读并遵守须知 </span><span class="blue-font" @click="lookAgreement">《协议查看》</span>
        </div>
        <el-form-item>
          <el-button @click="handleSignUp" class="submit" type="primary">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sign',
  data() {
    return {
      form: {},
      isRead: 0,
      seconds: '60',
      active: 0,
      phoneReg: /^1[3456789]\d{9}$/,
      passReg: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=<>/?]{8,16}$/,
    };
  },
  methods: {
    // 密码二次校验
    validatePassword(rule, value, callback) {
      if (value !== this.form.user_pwd) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    // 注册-提交
    handleSignUp() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.isRead == 0) return this.$message.error('请阅读并遵守须知');
        const data = {
          code: this.form.code,
          user_phone: this.form.user_phone,
          user_pwd: this.form.user_pwd,
          user_pwd_confirm: this.form.user_pwd_confirm,
        };
        this.$request.post('/individual/registration', data).then((res) => {
          this.$message.success('注册成功');
          this.$emit('gologin');
        });
      });
    },

    // 获取验证码
    sendCode() {
      if (!this.phoneReg.test(this.form.user_phone)) return this.$message.error('请输入正确的手机号');
      this.getCode();
      this.$request
        .post('/collective/sms/sendCode', {
          mobile: this.form.user_phone,
          type: 'registration',
        })
        .then((res) => {
          this.$message.success('发送成功');
        });
    },

    // 查看协议
    lookAgreement() {
      this.$emit('lookAgreement');
    },
    // 获取验证码显示倒计时
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.seconds = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.seconds > 0 && this.seconds <= TIME_COUNT) {
            this.seconds--;
          } else {
            this.seconds = '60';
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.signin {
  margin: 0 auto;
  position: relative;
  align-self: center;

  .signin_title {
    font-size: 36px;
    font-weight: 700;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }

  .topimg {
    position: absolute;
    top: -37px;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0 auto;
    width: 232px;
    height: 76px;
  }
}

.form {
  margin-top: 24px;

  /deep/ .el-input {
    width: 490px;
    font-size: 18px;
    border-radius: 4px;

    .el-input__inner {
      width: 100%;
      height: 56px;
      color: #333333;
    }
    .el-input__inner::placeholder {
      color: #999999;
      font-size: 18px;
    }
  }

  /deep/ .el-form-item__label {
    text-align: left;
    color: #262626;
  }
  /deep/.code {
    .el-input {
      width: 320px;
    }
    .el-button--primary {
      background-color: #ffffff;
      color: #1b70ff;
      width: 154px;
      height: 54px;
      margin-left: 16px;
      border-radius: 4px;
    }
  }

  /deep/ .phone {
    .el-input {
      width: 314px;
    }
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
    .el-autocomplete {
      width: 314px;
    }
    .el-checkbox {
      width: 164px;
      height: 53px;
      margin-left: 10px;
      border-radius: 4px;
      border: 1px solid rgba(27, 112, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .submit {
    width: 490px;
    margin-top: 20px;
    background: #1b70ff;
    color: #ffffff;
    height: 60px;
    font-size: 24px;
  }

  .left {
    margin-left: 100px;
    text-align: left;
    .blue-font {
      cursor: pointer;
      color: #1b70ff;
    }
    .mr-6 {
      margin-right: 6px;
    }
  }
}
</style>
<style>
.signin .el-form-item__error {
  position: absolute;
  top: 100%;
  left: 100px;
}
</style>
